import { observer } from 'mobx-react-lite'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { DocMenuContainer } from 'components/DocMenu/DocMenuContainer'
import { FileMenuButtonProps } from './Types'
import { useArticleView } from 'providers/ArticleViewProvider/ArticleViewProvider'
import { ArticleView } from 'types'
import { MoreDots } from 'blaze-ui/icons'
import { MoreDots as MoreDots24 } from 'blaze-ui/icons/24'
import { Button } from './Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const FileMenuButton = observer(({ articleId }: FileMenuButtonProps) => {
  const articleView = useArticleView() || ArticleView.Reading
  const { isMobile } = useResponsiveDesign()

  return (
    <DropdownTrigger placement="bottom-start">
      <Button icon={isMobile ? MoreDots24 : MoreDots} aria-label="File Menu" />
      {(close) => (
        <DocMenuContainer
          id={articleId}
          articleView={articleView}
          hiddenKeys={new Set(['openInNewTab', 'rename', 'share'])}
          dismiss={close}
          onAction={() => {
            close()
          }}
        />
      )}
    </DropdownTrigger>
  )
})
